import {
  AppointmentControllerService,
  AppointmentParticipantResponse,
  AppointmentResponse,
  AppointmentSchedulingControllerService,
  AppointmentUpdateRequest,
  AvailableSlotResponse,
  ScheduleAppointmentRequest
} from "@9amhealth/openapi";

export type ScheduleAppointmentTypes = Parameters<
  typeof AppointmentSchedulingControllerService.getAvailableSlots
>[0];

export type SchedulerApi = {
  getAvailableSlots(
    type: ScheduleAppointmentTypes,
    from: string,
    to: string,
    participantUserIds?: string[]
  ): Promise<AvailableSlotResponse[]>;
  scheduleAppointment(
    type: ScheduleAppointmentTypes,
    body: ScheduleAppointmentRequest
  ): Promise<AppointmentResponse>;
  updateAppointment(
    appointmentId: string,
    body: AppointmentUpdateRequest
  ): Promise<AppointmentResponse>;
  getPreviousProvider?(
    type: ScheduleAppointmentTypes
  ): Promise<AppointmentParticipantResponse | null>;
};

export const memberSchedulerApi: SchedulerApi = {
  getAvailableSlots: async (type, from, to, participantUserIds) => {
    const { data } =
      await AppointmentSchedulingControllerService.getAvailableSlots(
        type,
        from,
        to,
        participantUserIds
      );
    return data;
  },
  scheduleAppointment: async (type, body) => {
    const { data } =
      await AppointmentSchedulingControllerService.scheduleAppointment(
        type,
        body
      );
    return data;
  },
  updateAppointment: async (appointmentId, body) => {
    const { data } = await AppointmentControllerService.updateMemberAppointment(
      appointmentId,
      body
    );
    return data;
  },
  getPreviousProvider: async (type) => {
    const { data } =
      await AppointmentControllerService.getParticipantsInfoForMostRecentAppointmentWithType(
        type
      );
    return (data[0] ?? null) as AppointmentParticipantResponse | null;
  }
};
